import { LoadingSpinner } from '@web_opxp/components';
import { AuthActions } from '@web_opxp/features';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { sessionStorage } from 'web_core_library';
import ENV from '../../base/env';
import { redirectToCheckoutCancel, redirectToCheckoutError, redirectToCheckoutSuccess } from '../../base/utils';
import MoneybackGuarantee from '../../components/moneyback/MoneybackGuarantee';
import ChargebeeService from '../chargebeeService';
import * as Selectors from '../selectors';
import { CheckoutActions } from '../slice';

export default function Progress() {
  const { planId } = useParams<{ planId: string }>();

  const dispatch = useDispatch();

  const isAppLoading = !useSelector(Selectors.isCheckoutReady);
  const hostedPage = useSelector(Selectors.getHostedPageData);

  useEffect(() => {
    if (isAppLoading || !planId || !dispatch) {
      return;
    }
    // wait for product id and fire start action as soon as product id is given
    dispatch(CheckoutActions.startCheckout(planId));
  }, [dispatch, isAppLoading, planId]);

  useEffect(() => {
    if (!hostedPage) {
      return;
    }
    ChargebeeService.openCheckout(
      hostedPage,
      () => {
        sessionStorage.save('userIsFreshPremium', true);
        dispatch(AuthActions.setUserPremium());
        redirectToCheckoutSuccess();
      },
      () => {
        dispatch(CheckoutActions.checkoutClosed());
        redirectToCheckoutCancel();
      },
      undefined,
      () => {
        dispatch(CheckoutActions.checkoutClosed());
        redirectToCheckoutError();
      }
    );
  }, [hostedPage, dispatch]);

  return (
    <>
      <div className="panel" data-testid="progress-panel">
        <LoadingSpinner assetsUrl={ENV.AssetsBaseUrl} />
      </div>
      <MoneybackGuarantee />
    </>
  );
}
